import request from "@/utils/request";

export const countOrder = (report) => {
  return request({
    url: "/api/report/count/order",
    method: "post",
    data: report
  });
};


export const findByTime = (projectId, query) => {
  return request({
    url: `/api/report/time/${projectId}`,
    method: "post",
    data: query
  });
};
/**
 * 获取已经支付的人数
 * @param projectId
 * @returns {*}
 */
export const getPay = (projectId) => {
  return request({
    url: `/api/report/pay/${projectId}`,
    method: "post",
  });
};

